import { render, staticRenderFns } from "./GptChatSession.vue?vue&type=template&id=33c80a88&scoped=true&"
import script from "./GptChatSession.vue?vue&type=script&lang=js&"
export * from "./GptChatSession.vue?vue&type=script&lang=js&"
import style0 from "./GptChatSession.vue?vue&type=style&index=0&id=33c80a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c80a88",
  null
  
)

export default component.exports